import './index.scss';
import './scripts/debug/init';
import { createRoot } from 'react-dom/client';
import { initErrorHandlers, setRouter } from './scripts/error-handler';
import { router } from './scripts/router';
import { WalletApp } from './wallet';
import { Root } from './Root';

// Initialize global error handlers
initErrorHandlers();

// Store router instance for error handling
setRouter(router);

createRoot(document.getElementById('root')!).render(
  <>
    <Root />
    <WalletApp />
  </>
);
